{
  "id": "shelf",
  "name": "Shelf",
  "builds": "product",
  "category": "furniture",
  "note": "The cleat carries it all — screw down the whole seam.",
  "skill": "fineShelving",
  "duration": 35,
  "offeredBy": "bench",
  "fastener": "screws",
  "value": 9,
  "widthIn": 48,
  "heightIn": 8,
  "slots": [
    {
      "id": "plank-0",
      "role": "plank",
      "part": {
        "widthIn": 6,
        "lengthIn": 48,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 24,
      "yIn": 4,
      "angleDeg": 90,
      "zIn": 0
    },
    {
      "id": "cleat-0",
      "role": "cleat",
      "part": {
        "widthIn": 6,
        "lengthIn": 48,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 24,
      "yIn": 1.5,
      "angleDeg": 90,
      "zIn": 1,
      "onEdge": true
    }
  ],
  "fasteners": [
    {
      "xIn": 8,
      "yIn": 1.5
    },
    {
      "xIn": 24,
      "yIn": 1.5
    },
    {
      "xIn": 40,
      "yIn": 1.5
    }
  ]
}
